'use strict';

const config = ($provide, $httpProvider) => {
  'ngInject';

  /**
   * Atatus integration
   * @see https://www.atatus.com/docs/javascript-frameworks/angular
   */
  $provide.decorator('$exceptionHandler', ($delegate, $window) => {
    'ngInject';

    return (exception, cause) => {
      if ($window.atatus) {
        $window.atatus.notify(exception);
      }
      // (Optional) Pass the error through to the delegate
      $delegate(exception, cause);
    };
  });
  $httpProvider.interceptors.push('errorHttpInterceptor');
  /**
   * /Atatus integration
   */
};

export default config;
